import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { getRequirementIconAndLabel } from './getRequirementIconAndLabel'

const RequirementText = styled.span`
  text-transform: uppercase;
  line-height: 1;
`

function RequirementLabel({ requirement }) {
  const { label } = getRequirementIconAndLabel(requirement)

  return <RequirementText>{label}</RequirementText>
}

RequirementLabel.propTypes = {
  requirement: PropTypes.shape({
    type: PropTypes.string,
    params: PropTypes.shape({}),
  }).isRequired,
}

export { RequirementLabel }
